var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgUserPlus = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.875 9.188a3.563 3.563 0 1 0 0-7.126 3.563 3.563 0 0 0 0 7.126ZM2.019 16.5l.76-2.839a3 3 0 0 1 2.9-2.223h4.395a3 3 0 0 1 2.898 2.223l.762 2.839m-1.359-7.312h4.875M14.813 6.75v4.875" }) }))); };
export default SvgUserPlus;
